import React, { memo } from 'react'
import PropTypes from 'prop-types'
import ArrowBackIcon from '@material-ui/icons/ArrowBack'
import ButtonBase from '@material-ui/core/ButtonBase'
import { Collapse, Slide } from '@material-ui/core'
import clsx from 'clsx'
import EditableHTML from '@v4/components/common/EditableHTML'
import { useBackwardsAction } from './BackwardsAction.hooks'

const BackwardsAction = props => {
	const [{ classes, show, className, isLoading, label, withShadow, align }, { handleClick }] = useBackwardsAction(
		props,
	)

	return (
		<Collapse in={show}>
			<Slide direction="right" in={show} mountOnEnter unmountOnExit timeout={300}>
				<div className={classes.content}>
					<ButtonBase
						className={clsx(classes.button, className, 'question-backward-button')}
						aria-label="go-back"
						onClick={handleClick}
						disableRipple
						tabIndex={0}
						disabled={isLoading}
					>
						<ArrowBackIcon fontSize="small" className="question-backward-icon" />
						&nbsp;
						<EditableHTML
							html={label}
							className={clsx(classes.text, 'question-backward-text')}
							align={align}
							shadow={withShadow}
						/>
					</ButtonBase>
				</div>
			</Slide>
		</Collapse>
	)
}

BackwardsAction.propTypes = {
	label: PropTypes.string,
	className: PropTypes.string,
	withShadow: PropTypes.bool,
}

BackwardsAction.defaultProps = {
	label: null,
}

export default memo(BackwardsAction)
